import { CheckCircle } from 'lucide-react';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { useAuthTokenQuery } from '@/modules/auth/queries/useAuthTokenQuery';
import { VoiceConversationWidget } from '@/modules/elevenlabs/components/VoiceConversationWidget';
import { useJobQuery } from '@/modules/jobs/queries/useJobQuery';
import { SignupFlowHeader } from '@/modules/signup-flow/components/SignupFlowHeader';
import { Button } from '@/modules/ui/components/button/Button';
import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';

export const CompanyIntake = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const [isCompleted, setIsCompleted] = useState(false);

  const { data: job } = useJobQuery(jobId ?? '', { enabled: !!jobId });
  const { data: currentUser } = useCurrentUserQuery();
  const { data: authToken } = useAuthTokenQuery({ enabled: !!currentUser });
  const handleFinish = () => {
    setIsCompleted(true);
  };

  if (isCompleted) {
    return (
      <div className="flex min-h-screen flex-col bg-gradient-to-br from-neutral-50 to-neutral-100">
        <main className="mx-auto flex w-full max-w-2xl flex-1 flex-col items-center justify-center px-4 py-8 sm:px-6 md:py-12 lg:px-8">
          <div className="flex flex-col items-center text-center">
            <div className="bg-semantic-560/10 mb-6 flex h-16 w-16 items-center justify-center rounded-full">
              <CheckCircle className="text-semantic-560 h-8 w-8" />
            </div>

            <h1 className="text-primary-700 mb-3 text-2xl font-semibold">
              Intake session completed
            </h1>

            <p className="text-neutral-650 mb-8">
              Your responses have been recorded. This helps us to find perfect
              candidates for {job?.title} role.
            </p>

            <Button asChild>
              <Link to="/hm">Continue to dashboard</Link>
            </Button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-neutral-50 to-neutral-100">
      <main className="mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-4 py-8 sm:px-6 md:py-12 lg:px-8">
        <SignupFlowHeader
          title={`Tell us about ${job?.company.name}`}
          subtitle={
            job?.title
              ? `We'll ask a few quick questions to source for the ${job.title} role. It takes about 3 minutes.`
              : 'Loading...'
          }
          className="mx-auto mb-8 max-w-3xl [&_h2]:mx-auto [&_h2]:max-w-3xl [&_h2]:break-words [&_h5]:mx-auto [&_h5]:max-w-3xl [&_h5]:break-words"
        />

        <div className="space-y-6">
          {currentUser?.firstName && authToken && job && (
            <VoiceConversationWidget
              authorization={{ agentId: 'agent_4401k9vjerqhew7v5re9m53d7bd2' }}
              dynamicVariables={{
                job_id: job.id,
                job_name: job.title,
                company_id: job.company.id,
                company_name: job.company.name,
                user_first_name: currentUser.firstName,
                secret_auth_header: `Bearer ${authToken.accessToken}`,
              }}
              onFinish={handleFinish}
            />
          )}
        </div>
      </main>
    </div>
  );
};
